<template>
  <div class="valore-rule-page">
    <div class="title">积分规则说明</div>
    <div class="rule-content" v-html="activityRule"></div>
    <div class="bottom-text">最终解释权归 VALORE AOE 所有</div>
  </div>
</template>

<style scoped>
.valore-rule-page {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: white;
}

.title {
  position: absolute;
  top: 5vh;
  left: 5vw;
  color: black;
  font-weight: bold;
  font-size: 5vw;
}

.rule-content {
  position: absolute;
  top: 10vh;
  left: 5vw;
  width: 90vw;
  font-size: 3.5vw;
  color: black;
  line-height: 1.6;
  letter-spacing: 1.5px;
}

.bottom-text {
  width: 100vw;
  font-weight: 300;
  height: 10vh;
  color: rgb(204, 204, 204);
  font-size: 3.6vw;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>

<script>
import { getTemplate } from '../../api/api'

export default {
  name: 'ValoreRule',
  data() {
    return {
      deptId: process.env.ENV_NUM === '1' ? '94' : '1028',
      activityRule: '',
    }
  },
  methods: {
    async queryTemplate() {
      const res = await getTemplate(this.deptId)
      return res && res.data && res.data.data ? res.data.data.activityRule : ''
    }
  },
  async mounted() {
    this.activityRule = await this.queryTemplate()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Valore/Rule.vue